import React from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Grow from "@material-ui/core/Grow";
import useStyles from "./styles";

const NotFound = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <CssBaseline />
      <div className={classes.container}>
        <Typography variant="h1" color="inherit" className={clsx(classes.fontMedium, classes.mb16)}>
          404
        </Typography>

        <Grow in={true} timeout={600}>
          <Typography variant="h5" color="inherit" className={classes.mb16}>
            Sorry, but we could not find the page you were looking for
          </Typography>
        </Grow>

        <Link to="/" className={classes.fontMedium}>
          Return home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
